import moment from "moment";

export const handleChangeHelper = (
  name,
  value,
  setFieldValue,
  productName,
  formikValues,
  arrayIndex
) => {};

export const handleOnAcceptHelper = (
  name,
  value,
  setFieldValue,
  productName,
  formikValues,
  arrayIndex
) => {
  // console.log("productName: ", productName);
  const formattedValue = moment(value).format("YYYY-MM-DD");
  if (productName === "Reliance IPA") {
    if (
      formikValues?.primaryDetails[arrayIndex]?.RelationshipWithProposerID ===
      "345"
    ) {
      if (name === `primaryDetails[${arrayIndex}].DOB`) {
        setFieldValue(`proposerDetails.DOB`, formattedValue);
      }
    }
  }
};
